export default __webpack_public_path__ + "static/media/red_team_lost.31584784.webp";